//https://stackoverflow.com/a/76281017
export default {
	beforeMount: function (el, binding) {
		//  check that click was outside the el and his children
		el.clickOutsideEvent = function (event) {
			// and if it did, call method provided in attribute value
			if (!(el === event.target || el.contains(event.target))) {
				binding.value(event);
			}
		};

		document.body.addEventListener("click", el.clickOutsideEvent);
		
	},
	unmounted: function (el) {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	},
};